import { createAction } from 'redux-actions';
import { SagaIterator } from 'redux-saga';
import { call, put, takeEvery } from 'redux-saga/effects';
import { UserSliceType, userReducer } from '@/api/user/user.reducer';
import { mergeSaga } from '@/utils/redux-saga/merge-saga';
import { vipApi } from '@/utils/vip-api';
import { API_PATH } from '@/constants';
import { BitrixServiceClient } from '@/shared/services/bitrix-service';

const suffix = `/${userReducer.sliceName}/app`;

const GET_USER_INFO = `GET_USER_INFO${suffix}`;
export const getUserInfoAction = createAction(GET_USER_INFO);

const GET_USER_INFO_ERROR = `GET_USER_INFO_ERROR${suffix}`;
const getUserInfoErrorAction = createAction<any>(GET_USER_INFO_ERROR);

const GET_USER_INFO_SUCCESS = `GET_USER_INFO_SUCCESS${suffix}`;
const getUserInfoSuccessAction = createAction<any>(GET_USER_INFO_SUCCESS);

function* getUserInfoWatcher(): SagaIterator {
  yield takeEvery(GET_USER_INFO, getUserInfoWorker);
}
mergeSaga(getUserInfoWatcher);

function* getUserInfoWorker(): SagaIterator {
  try {
    const result = yield call(getApiPlayer);
    const user = result.data;

    const userLocalStorage = localStorage.getItem('user');
    if (userLocalStorage == null) {
      localStorage.setItem('user', JSON.stringify(user));
    } else {
      const LocalUserInfo = localStorage.getItem('user');
      if (LocalUserInfo) {
        const userInfo = JSON.parse(LocalUserInfo);
        const newUserInfo = { ...userInfo, ...user };
        localStorage.setItem('user', JSON.stringify(newUserInfo));

        if (window.innerWidth >= 768) {
          BitrixServiceClient.waitForBitrixReady().then(() => BitrixServiceClient.setCustomData(newUserInfo));
        }
      }
    }

    yield put(getUserInfoSuccessAction(result));

    if (user.tour_displayed == 0) {
      if (!localStorage.getItem(`tour_display_${user.username}`) && !localStorage.getItem(`tour_steps_displayed_${user.username}`)) {
        localStorage.setItem(`tour_display_${user.username}`, '0');
        localStorage.setItem(`tour_steps_displayed_${user.username}`, '[]');

        setTimeout(() => {
          window.parent.postMessage(
            {
              data: {
                data: {},
              },
              action: 'call-tour',
            },
            '*',
          );
        }, 1500);
      }
    } else {
      if (localStorage.getItem(`tour_display_${user.username}`)) {
        localStorage.removeItem(`tour_display_${user.username}`);
      }
      if (localStorage.getItem(`tour_steps_displayed_${user.username}`)) {
        localStorage.removeItem(`tour_steps_displayed_${user.username}`);
      }
    }
  } catch (e: any) {
    yield put(getUserInfoErrorAction(e));
  }
}

const getApiPlayer = (): Request => {
  return vipApi(API_PATH.USER.GET_USER_INFO, 'get', {});
};

const reduceHandlers = {
  [GET_USER_INFO]: (slice: UserSliceType): UserSliceType => ({
    ...slice,
    isLoading: true,
    isLoadingUserInfo: true,
  }),
  [GET_USER_INFO_SUCCESS]: (slice: UserSliceType, action: any): UserSliceType => {
    return {
      ...slice,
      isLoading: false,
      isLoadingUserInfo: false,
      loggedInUser: action.payload.data,
      userInfo: action.payload.data,
    };
  },
  [GET_USER_INFO_ERROR]: (slice: UserSliceType): UserSliceType => ({
    ...slice,
    isLoading: false,
    isLoadingUserInfo: false,
  }),
};
userReducer.addActionReducerMap(reduceHandlers);
